// Store display names (platform-wide). Store A = Australia, Store B = International.
export const STORE_NAME = { A: 'TEAMM8 Australia', B: 'TEAMM8 International' };
export const STORE_SHORT = { A: 'Australia', B: 'International' };

export const storeName = (code) => STORE_NAME[code] || `Store ${code}`;
export const storeShort = (code) => STORE_SHORT[code] || code;
